import { 
  FileInput, 
  Brain, 
  Link2, 
  Workflow, 
  Bot, 
  FileText, 
  Share, 
  MessageSquare, 
  GitBranch, 
  FileSliders, 
  FileCode,
  Lightbulb,
  Layout,
  FolderOpen,
  Target
} from 'lucide-react';
import { FeatureSectionData } from './types';
import React from 'react';

export const featureSections: FeatureSectionData[] = [
  {
    id: "ai-assistants",
    title: "AI Assistants",
    subtitle: "Train AI to Work for You.",
    description: "Create AI-powered assistants that can answer FAQs, automate customer interactions, and provide real-time support—all trained on your data.",
    imagePlaceholder: "/placeholder.svg",
    icon: React.createElement(Bot, { size: 20, className: "text-white" }),
    features: [
      {
        icon: React.createElement(FileText, { size: 20, className: "text-white" }),
        title: "Custom Knowledge Base",
        description: "Train AI with your content, documents, and FAQs."
      },
      {
        icon: React.createElement(Share, { size: 20, className: "text-white" }),
        title: "Deploy Anywhere",
        description: "Embed AI on websites, chat platforms, or direct links."
      },
      {
        icon: React.createElement(Bot, { size: 20, className: "text-white" }),
        title: "Multi-Model AI Support",
        description: "Use GPT-4, Claude, and Gemini AI models."
      },
      {
        icon: React.createElement(MessageSquare, { size: 20, className: "text-white" }),
        title: "Real-Time Learning & Context Retention",
        description: "AI adapts and improves responses."
      }
    ],
    ctaText: "Try AI Assistants Now",
    color: "bg-[#FEE6D8]/20"
  },
  {
    id: "intelliforms",
    title: "IntelliForms",
    subtitle: "AI-Powered Forms That Do More.",
    description: "Build smarter, adaptive forms that dynamically respond to users, automate workflows, and generate intelligent outputs—without manual input.",
    imagePlaceholder: "/placeholder.svg",
    icon: React.createElement(FileInput, { size: 20, className: "text-white" }),
    features: [
      {
        icon: React.createElement(FileInput, { size: 20, className: "text-white" }),
        title: "Adaptive Form Fields",
        description: "Fields change based on user responses."
      },
      {
        icon: React.createElement(Brain, { size: 20, className: "text-white" }),
        title: "AI-Powered Output",
        description: "Generates responses automatically."
      },
      {
        icon: React.createElement(Link2, { size: 20, className: "text-white" }),
        title: "Integrates with CRMs & Google Sheets",
        description: "Seamlessly connect your data."
      },
      {
        icon: React.createElement(Workflow, { size: 20, className: "text-white" }),
        title: "Workflow Automation",
        description: "Send responses, trigger actions, and streamline operations."
      }
    ],
    ctaText: "Start Building Smarter Forms",
    color: "bg-white"
  },
  {
    id: "flow-builder",
    title: "Flow Builder",
    subtitle: "No-Code AI Automation at Your Fingertips.",
    description: "Visually design AI-driven workflows, automate conversations, and integrate AI-powered responses with an easy-to-use drag-and-drop builder.",
    imagePlaceholder: "/placeholder.svg",
    icon: React.createElement(GitBranch, { size: 20, className: "text-white" }),
    features: [
      {
        icon: React.createElement(GitBranch, { size: 20, className: "text-white" }),
        title: "Drag-and-Drop Interface",
        description: "Easily create AI-powered flows."
      },
      {
        icon: React.createElement(FileSliders, { size: 20, className: "text-white" }),
        title: "Conditional Logic",
        description: "Set up if/then responses based on user actions."
      },
      {
        icon: React.createElement(FileCode, { size: 20, className: "text-white" }),
        title: "AI Mode Integration",
        description: "Switch between structured flows and freeform AI conversations."
      },
      {
        icon: React.createElement(Link2, { size: 20, className: "text-white" }),
        title: "Webhook & API Support",
        description: "Connect to external tools and databases."
      }
    ],
    ctaText: "See the Flow Builder in Action",
    color: "bg-white"
  },
  {
    id: "spotlight-pages",
    title: "Spotlight Pages",
    subtitle: "Bring Anything to Life with an AI-Powered Spotlight",
    description: "Whether you're showcasing a personal brand, a new product, a local business, or a special event, Spotlight gives it a dedicated home. Create a single, beautiful page where visitors can explore content, watch videos, and get instant answers from an AI assistant trained on your specific information. It's more than a landing page, it's an interactive experience.",
    imagePlaceholder: "/placeholder.svg",
    icon: React.createElement(Lightbulb, { size: 20, className: "text-white" }),
    features: [
      {
        icon: React.createElement(Layout, { size: 20, className: "text-white" }),
        title: "Versatile by Design",
        description: "Showcase anything from a personal bio and portfolio to a product launch, an event schedule, or a complete business overview."
      },
      {
        icon: React.createElement(MessageSquare, { size: 20, className: "text-white" }),
        title: "Instant AI-Powered Conversations",
        description: "Embed a chatbot trained on your unique content, allowing visitors to ask questions and get immediate, relevant information."
      },
      {
        icon: React.createElement(FolderOpen, { size: 20, className: "text-white" }),
        title: "Centralized Content Hub",
        description: "Consolidate all your important information in one place with a customizable profile, header links, social buttons, and embedded videos."
      },
      {
        icon: React.createElement(Target, { size: 20, className: "text-white" }),
        title: "Turn passive visitors into active leads",
        description: "Use a dedicated call-to-action button and strategically placed links to guide your audience toward key conversion points, whether it's booking a call, downloading a resource, or exploring your products."
      }
    ],
    ctaText: "Create Your First Spotlight Page",
    color: "bg-white"
  }
];
